// @flow
import nothing from 'PublicPath'; // eslint-disable-line no-unused-vars
import renderReact from 'utils/renderReact';
import createStore from './redux/main';
import App from './App';

export default renderReact('main', App, createStore);
